import isNil from 'lodash/isNil';

export const DEFAULT_AVATARS = [
  'https://static.treedis.com/avatars/62cd861b48960be56eae26b8.glb',
  'https://static.treedis.com/avatars/62f3ae0a3e172e00542676ec.glb',
  'https://static.treedis.com/avatars/635fcfdb41d7a22057ef1495.glb',
  'https://static.treedis.com/avatars/63626a6efff3a4d4797dae05.glb',
  'https://static.treedis.com/avatars/63626a94fff3a4d4797dae46.glb',
  'https://static.treedis.com/avatars/63626accfff3a4d4797daeb5.glb',
  'https://static.treedis.com/avatars/63626adffff3a4d4797daee4.glb',
  'https://static.treedis.com/avatars/63626b6e52b953b7b71fce6a.glb',
  'https://static.treedis.com/avatars/63626bb152b953b7b71fcef0.glb',
  'https://static.treedis.com/avatars/63626bd552b953b7b71fcf39.glb',
  'https://static.treedis.com/avatars/63626c8a52b953b7b71fd044.glb',
  'https://static.treedis.com/avatars/636269effff3a4d4797dad1f.glb',
  'https://static.treedis.com/avatars/6317163a666e9239d9c635cf.glb',
  'https://static.treedis.com/avatars/63171619666e9239d9c63168.glb',
];

export const AVATAR_CIRCLE_RADIUS = 0.65;
export const AVATAR_WALKING_SPEED = 1.5; // Avatar speed in m/s
export const AVATAR_ROTATION_SPEED = 0.5; // Avatar rotation speed
export const AVATAR_ANIMATION_BLENDING = 0.2; // How smooth avatar animations transition between each other

export class Avatar {
  name: string;

  bodyType: 'fullbody' | 'halfBody';

  url: string;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  quaternionX: number;

  quaternionY: number;

  quaternionZ: number;

  quaternionW: number;

  uuid: string;

  color: string;

  muted: boolean;

  visible?: boolean;

  degree?: number;

  constructor(model: any = {}) {
    this.name = model.name || '';
    this.bodyType = model.bodyType;
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || '0xEA475C';
    this.muted = isNil(model.muted) || model.muted;
    this.visible = typeof model.visible === 'boolean' ? model.visible : true;
    this.degree = model.degree || null;
  }
}
